/**
 * Tabbed Collections - Tab Management Only
 * Navigation is handled by UniversalSwiper
 * 
 * @version 2.0.0
 */

(function() {
  'use strict';

  function initSwiperForContent(content) {
    if (!content) return;
    
    const swiperEl = content.querySelector('.swiper-carousel');
    if (!swiperEl || swiperEl.swiper) return;
    
    if (window.UniversalSwiper && typeof window.UniversalSwiper.init === 'function') {
      window.UniversalSwiper.init();
    }
  }

  function initTabs(section) {
    const tabs = section.querySelectorAll('.tabbed-nav__tab');
    const contents = section.querySelectorAll('.collection-content');
    const navButtonGroups = section.querySelectorAll('.tabbed-nav__buttons');
    
    if (tabs.length === 0 || contents.length === 0) return;
    
    // Initialize first tab
    initSwiperForContent(contents[0]);
    
    // Tab click handlers
    tabs.forEach((tab) => {
      tab.addEventListener('click', function() {
        const blockId = tab.dataset.blockId;
        
        // Toggle active states
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        navButtonGroups.forEach(n => n.classList.remove('active'));
        
        tab.classList.add('active');
        
        // Show content
        const activeContent = section.querySelector(`.collection-content[data-block-id="${blockId}"]`);
        if (activeContent) {
          activeContent.classList.add('active');
          initSwiperForContent(activeContent);
          
          // Forzar update del swiper después de mostrarlo
          setTimeout(() => {
            const swiperEl = activeContent.querySelector('.swiper-carousel');
            if (swiperEl && swiperEl.swiper) {
              swiperEl.swiper.update();
              
              // Forzar re-cálculo de estados de botones
              const swiper = swiperEl.swiper;
              
              // Trigger slideChange event para actualizar estados
              if (swiper.emit) {
                swiper.emit('slideChange');
              }
            }
          }, 10);
        }
        
        // Show nav buttons
        const activeNav = section.querySelector(`.swiper-nav-${blockId}`);
        if (activeNav) {
          activeNav.classList.add('active');
        }
      });
    });
  }

  function initAllSections() {
    document.querySelectorAll('.tabbed-collections-section').forEach(initTabs);
  }

  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
      initAllSections();
    }
    
    setTimeout(initAllSections, 100);
  }

  autoInit();
})();